export const mentorApplicationFormValidation = (applicationPiece, mentorApplicationPiece,) => {
  const {
    intendedLearners,
    contentDeliveryStatus,
    courseDuration,
    courseContentHours,
    weeklyDaySchedule,
    courseFee,
    courseCommencementDate,
    calendlyLinkOptional,
    courseBrochure,
    demoLectureURL,
  } = applicationPiece;

  const {
    personalInformation,
    qualifications,
  } = mentorApplicationPiece;

  const validPersonalInformation =
    personalInformation?.name &&
    typeof personalInformation.name === 'string' &&
    personalInformation.name.trim() !== '' &&

    personalInformation?.gender &&
    typeof personalInformation.gender === 'string' &&
    personalInformation.gender.trim() !== '' &&

    personalInformation?.email &&
    typeof personalInformation.email === 'string' &&
    personalInformation.email.trim() !== '' &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(personalInformation.email) && // Basic email validation

    personalInformation?.contact &&
    typeof personalInformation.contact === 'string' &&
    personalInformation.contact.trim() !== '' &&

    personalInformation?.country &&
    typeof personalInformation.country === 'object' &&
    Object.keys(personalInformation.country).length > 0 && // Has at least one key-value pair
    Object.values(personalInformation.country).some(value => value !== null && value !== undefined && value !== '') && // At least one non-empty value

    personalInformation?.linkedInURL &&
    typeof personalInformation.linkedInURL === 'string' &&
    personalInformation.linkedInURL.trim() !== '' // Valid URL format

  // NEW VALIDATIONS FOR QUALIFICATIONS
  const validQualifications =
    // Educational Qualification
    qualifications?.educationalQualification?.title &&
    typeof qualifications.educationalQualification.title === 'string' &&
    qualifications.educationalQualification.title.trim() !== '' &&

    // Supporting Document is optional, so no validation needed for presence
    // But if present, it should be a File object
    (!qualifications?.educationalQualification?.supportingDocument ||
      qualifications.educationalQualification.supportingDocument instanceof File) &&

    // Current Professional Role
    qualifications?.currentProfessionalRole?.title &&
    typeof qualifications.currentProfessionalRole.title === 'string' &&
    qualifications.currentProfessionalRole.title.trim() !== '' &&

    // Resume is required and must be a File object
    qualifications?.currentProfessionalRole?.resume &&
    qualifications.currentProfessionalRole.resume instanceof File &&

    // Work Experience
    !isNaN(Number(qualifications.workExperience)) && // Must be a valid number
    Number(qualifications.workExperience) > 0 && // Must be greater than 0

    // Previously Worked With LMS - must be boolean (true or false)
    typeof qualifications?.previouslyWorkedWithLMS === 'boolean';

  // Check whatWillStudentsLearn - array of exactly 4 non-empty strings
  const validWhatWillStudentsLearn =
    Array.isArray(intendedLearners?.whatWillStudentsLearn) &&
    intendedLearners.whatWillStudentsLearn.length === 4 &&
    intendedLearners.whatWillStudentsLearn.every(item =>
      typeof item === 'string' && item.trim() !== ''
    );

  // Check prerequisites - array with at least one non-empty string
  const validPrerequisites =
    Array.isArray(intendedLearners?.prerequisites) &&
    intendedLearners.prerequisites.length >= 1 &&
    intendedLearners.prerequisites.every(item =>
      typeof item === 'string' && item.trim() !== ''
    );

  // Check intendedAudience - array with at least one non-empty string
  const validIntendedAudience =
    Array.isArray(intendedLearners?.intendedAudience) &&
    intendedLearners.intendedAudience.length >= 1 &&
    intendedLearners.intendedAudience.every(item =>
      typeof item === 'string' && item.trim() !== ''
    );

  // Check contentDeliveryStatus
  const validContentDeliveryStatus =
    ['live', 'recorded', 'hybrid'].includes(contentDeliveryStatus);

  // Check courseDuration - not 0 or "0"
  const validCourseDuration =
    courseDuration !== 0 && courseDuration !== "0" && courseDuration !== '';

  // Check courseContentHours - not 0 or "0"
  const validCourseContentHours =
    courseContentHours !== 0 && courseContentHours !== "0" && courseContentHours !== '';

  // Check weeklyDaySchedule - non-empty string
  const validWeeklyDaySchedule =
    typeof weeklyDaySchedule === 'string' && weeklyDaySchedule.trim() !== '';

  // Check courseFee
  const validCourseFee =
    courseFee?.currency &&
    courseFee.currency.trim() !== '' &&
    courseFee.amount !== 0 &&
    courseFee.amount !== "0" && courseFee.amount;

  // Check courseCommencementDate - valid date string (from input type="date")
  const validCourseCommencementDate =
    typeof courseCommencementDate === 'string' &&
    courseCommencementDate.trim() !== '' &&
    !isNaN(new Date(courseCommencementDate).getTime());

  // Check courseBrochure - File object is present (not null/undefined)
  const validCourseBrochure = !courseBrochure ||
    courseBrochure instanceof File;

  // Check optional calendlyLink - if present, must be valid URL
  const validCalendlyLink =
    !calendlyLinkOptional ||
    (typeof calendlyLinkOptional === 'string' &&
      calendlyLinkOptional.trim() !== '');

  // Check optional demoLectureURL - if present, must be valid URL
  const validDemoLectureURL =
    !demoLectureURL ||
    (typeof demoLectureURL === 'string' &&
      demoLectureURL.trim() !== '');

  // Set stepFiveComplete to true only if ALL conditions are met
  console.log({
    validWhatWillStudentsLearn,
    validPrerequisites,
    validIntendedAudience,
    validContentDeliveryStatus,
    validCourseDuration,
    validCourseContentHours,
    validWeeklyDaySchedule,
    validCourseFee,
    validCourseCommencementDate,
    validCourseBrochure,
    validCalendlyLink,
    validDemoLectureURL,
  });

  const isComplete =
    validWhatWillStudentsLearn &&
    validPrerequisites &&
    validIntendedAudience &&
    validContentDeliveryStatus &&
    validCourseDuration &&
    validCourseContentHours &&
    validWeeklyDaySchedule &&
    validCourseFee &&
    validCourseCommencementDate &&
    validCourseBrochure &&
    validCalendlyLink &&
    validDemoLectureURL && validPersonalInformation && validQualifications;

  return {
    isComplete,
    validWhatWillStudentsLearn,
    validPrerequisites,
    validIntendedAudience,
    validContentDeliveryStatus,
    validCourseDuration,
    validCourseContentHours,
    validWeeklyDaySchedule,
    validCourseFee,
    validCourseCommencementDate,
    validCourseBrochure,
    validCalendlyLink,
    validDemoLectureURL, validPersonalInformation,
    validQualifications,
  }
}